import {
  boardSharedFilters,
  type BoardSharedFilters,
} from './boardSharedFilters';

/**
 * The board's active shared filters from its search params. A hook so React
 * Compiler memoizes the result by its inputs: the page's memoized callbacks
 * read it, and a fresh object each render would make the compiler bail on
 * them (preserve-manual-memoization).
 */
export function useBoardSharedFilters(
  search: BoardSharedFilters,
): BoardSharedFilters {
  const {
    warehouseTypes,
    skuSearch,
    textSearch,
    stockStatuses,
    popularityCodes,
  } = search;
  return boardSharedFilters({
    warehouseTypes,
    skuSearch,
    textSearch,
    stockStatuses,
    popularityCodes,
  });
}
